// Widget Scripts
import themeBackground from './js/widgets/1-themeBackground.js';
import customTicketButton from './js/widgets/0-customTicketButton.js';
import mainSlideshow from './js/widgets/2-mainSlideshow.js';
import * as seoEvents from './js/widgets/seo-events-section/index.js';
import cardsWidget from './js/widgets/cardsWidget.js';
import scrollerSponsors from './js/widgets/7-scrollerSponsors.js';
import photoGallery from './js/widgets/photoGallery.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  themeBackground();
  customTicketButton();
  photoGallery();

  if (globalThis.location.pathname === '/') {
    mainSlideshow();
    seoEvents.autoEventFeed();
    seoEvents.customSeoBlock();
    cardsWidget(
      'cardWidgetFirst',
      typeof cardWidgetFirstOpts === 'undefined' ? null : cardWidgetFirstOpts,
      2,
    );
    cardsWidget(
      'cardWidgetSecond',
      typeof cardWidgetSecondOpts === 'undefined' ? null : cardWidgetSecondOpts,
      4,
    );
    scrollerSponsors();
  }
});
